import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UploadIcon } from 'components/elements/Icons';
import { useAppointmentActions } from 'hooks';
import AppointmentAttachmentItem from './AppointmentAttachmentItem';
import Styles from './styles';
import cn from 'classnames';

const useStyles = makeStyles(Styles);

function AppointmentAttachments({ files, id, attachmentUploadEnabled }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { upload, download, downloadingList, appointmentFiles } = useAppointmentActions(id, files);
  const uploadButtonClasses = cn(classes.uploadFileBtn, { [classes.uploadFileBtnActive]: attachmentUploadEnabled });
  const attachFileEvent = (e) => {
    upload({ attachments: e.target.files });
  };

  return (
    <Box className={classes.appointmentAttachments} data-testid="appointment-attachments">
      <div className={classes.attachmentsHeader}>
        <div className={classes.attachmentsHeaderTitleWrapper}>
          <Typography className={classes.healthcareServiceName} variant="h5" color="text" component="h3" noWrap>
            {t('shared_documents')}
          </Typography>
          <Typography variant="body1" color="textSecondary" component="p" noWrap>
            {t('all_documents_will_be_shared_between_you_and_your_provider')}
          </Typography>
        </div>
        <button className={uploadButtonClasses} type="button">
          <label htmlFor="attach">
            <span className={classes.attachLabel}>{t('attach')}</span>
            <UploadIcon classes={classes.uploadIcon} />
          </label>
          <input type="file" name="attach" id="attach" accept="image/gif, image/jpeg, image/png, application/pdf" onChange={attachFileEvent} />
        </button>
      </div>
      <div className={classes.attachmentsWrapper}>
        {appointmentFiles.length ? (
          appointmentFiles.map(({ key, filename, uploadedBy, createdAt }) => (
            <AppointmentAttachmentItem
              key={key}
              fileName={filename}
              uploadedBy={uploadedBy}
              createdAt={createdAt}
              isDisabled={downloadingList.includes(key)}
              onClick={() => download(key, filename)}
            />
          ))
        ) : (
          <div className={classes.noDocuments}>
            <Typography variant="body1" color="textSecondary" component="p">
              {t('no_documents_available')}
            </Typography>
          </div>
        )}
      </div>
    </Box>
  );
}

AppointmentAttachments.propTypes = {
  files: PropTypes.arrayOf(PropTypes.object).isRequired,
  id: PropTypes.string.isRequired,
  attachmentUploadEnabled: PropTypes.bool,
};

AppointmentAttachments.defaultProps = {
  attachmentUploadEnabled: true,
};

export default AppointmentAttachments;
